!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("react"), require("@material-ui/core"), require("@material-ui/styles")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core", "@material-ui/styles"], r) : r((e = e || self)["circular-progress-overlay"] = {}, e.React, e.core, e.styles);
}(this, function (e, r, t, o) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;

  var _n = function n() {
    return (_n = Object.assign || function (e) {
      for (var r, t = 1, o = arguments.length; t < o; t++) for (var n in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);

      return e;
    }).apply(this, arguments);
  };

  e.CircularProgressOverlay = function (e) {
    var i = e.isLoading,
        a = e.transitionDelay,
        l = void 0 === a ? 0 : a,
        s = e.opacity,
        c = e.spinnerColor,
        u = e.position,
        y = function (e, r) {
      var t = {};

      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;

        for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) r.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (t[o[n]] = e[o[n]]);
      }

      return t;
    }(e, ["isLoading", "transitionDelay", "opacity", "spinnerColor", "position"]),
        p = o.useTheme();

    if (!p) throw new Error("CircularProgressOverlay must be within a Theme Provider");

    var f = function (e) {
      return o.makeStyles(function () {
        return o.createStyles({
          circularProgress: {
            color: e
          }
        });
      })();
    }(c);

    return i ? r.createElement(t.Box, {
      zIndex: p.zIndex.modal + 1,
      position: u || "absolute",
      top: 0,
      left: 0,
      height: 1,
      width: 1,
      style: {
        backgroundColor: "rgba(255,255,255," + (void 0 !== s ? s : .75) + ")"
      }
    }, r.createElement(t.Fade, {
      in: i,
      style: {
        transitionDelay: i ? l + "ms" : "0ms"
      }
    }, r.createElement(t.Box, {
      height: 1,
      width: 1,
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      style: {
        backgroundColor: "rgba(255,255,255," + (void 0 !== s ? s : .75) + ")"
      }
    }, r.createElement(t.CircularProgress, _n({
      className: f.circularProgress,
      style: y.style
    }, y))))) : null;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});